<template>
	<div>
		<panel class="border border-secondary rounded mb-4" :noButton="true">
			<template slot="header">
				<h5>Pengecekan Kondisi Mobil - Kiri</h5>
			</template>
			<!-- <div class="p-10 w-100">
				<h5>Tipe Mobil</h5>
				<div class="row">
					<div class="col-6 col-md-3" style="padding-right:0;">
						<button 
							class="btn w-100" 
							:class="{'btn-info' : carTypes == 'sedan', 'btn-outline-info' : carTypes != 'sedan'}" 
							style="border-radius:5px 0px 0px 5px;border-right: none" type="button"
							@click="carTypes = 'sedan'"
							disabled
						>
							Sedan
						</button>
					</div>
					<div class="col-6 col-md-3" style="padding-left:0">
						<button 
							class="btn w-100" 
							:class="{'btn-info' : carTypes == 'minibus', 'btn-outline-info' : carTypes != 'minibus'}" 
							style="border-radius:0px 5px 5px 0px;" type="button"
							@click="carTypes = 'minibus'"
							disabled
						>
							Minibus
						</button>
					</div>
				</div>
			</div> -->
			<div class="row mt-3">
				<div class="col-sm-4 col-lg-2 col-12 label-car-type">
					<label>Pilih Jenis Kendaraan :</label>
				</div>
				<div class="col-sm-3 col-lg-2 col-6">
					<button 
							class="btn w-100" 
							:class="{'btn-info' : carTypes == 'sedan', 'btn-outline-info' : carTypes != 'sedan'}" 
							style="border-radius:50px" type="button"
							@click="carTypes = 'sedan'"
							disabled
						>
							Sedan
						</button>
				</div>
				<div class="col-sm-3 col-lg-2 col-6">
					<button 
							class="btn w-100" 
							:class="{'btn-info' : carTypes == 'minibus', 'btn-outline-info' : carTypes != 'minibus'}" 
							style="border-radius:50px" type="button"
							@click="carTypes = 'minibus'"
							disabled
						>
							Minibus
						</button>
				</div>
			</div>
			<div class="row mt-2">
				<div class="col-12 p-10" style="overflow-x:scroll">
					<div class="workOrderParent" :class="{'workOrderOuterLeftSedan' : carType == 'sedan', 'workOrderOuterLeftMinibus' : carType == 'minibus'}" v-if="!exit">
						<!-- <div class="workOrderInnerLeftSedan h-100 w-100" style="z-index:100"  @mousedown="(e) => {this.addShape(e , null)}">
						</div>
						<canvas class="workOrderInnerLeftSedan h-100 w-100"  id="canvasSedan" style="z-index:50;" >			
						</canvas> -->
						<template v-if="carType == 'sedan'">
							<div class="workOrderInnerLeftSedan h-100 w-100" style="z-index:100"  @mousedown="(e) => {this.addShape(e , null)}">
							</div>
							<canvas class="workOrderInnerLeftSedan h-100 w-100"  id="canvasSedan" style="z-index:50;" >
								
							</canvas>
						</template>
						<template v-else>
							<div class="workOrderInnerLeftMinibus h-100 w-100" style="z-index:100"  @mousedown="(e) => {this.addShape(e , null)}">
							</div>
							<canvas class="workOrderInnerLeftMinibus h-100 w-100"  id="canvasMinibus" style="z-index:50;" >
								
							</canvas>
						</template>
					</div>
					<div v-else>
						<img v-if="imageSrc" :src="env.baseImage + '/' + imageSrc"  class="workOrderParent"/>

						<div v-else class="mt-5 mb-5 text-center">
							<h2>Tidak Melakukan Tanda Terima</h2>
						</div>
					</div>
				</div>
				<div class="col-12 row mt-1 mb-5" v-if="!exit">
					<div class="col-12 mb-2 pl-4 mt-2">
						<label>Pilih Kondisi Berikut untuk Menandai Mobil</label>
					</div>
					<div class="col-sm-3 col-lg-2 pl-4 mt-2">
						<button :class="{'btn-green' : curShape == 'Boncel' , 'btn-outline-secondary' : curShape != 'Boncel'}" class="btn w-100" @click="curShape = 'Boncel'"><i class="fa fa-circle fa-lg mr-2 color-green"></i> Boncel</button>
					</div>
					<div class="col-sm-3 col-lg-2 pl-4 mt-2">
						<button :class="{'btn-blue' : curShape == 'Baret' , 'btn-outline-secondary' : curShape != 'Baret'}" class="btn w-100" @click="curShape = 'Baret'"><i class="fa fa-circle fa-lg mr-2 color-blue"></i> Baret</button>
					</div>
					<div class="col-sm-3 col-lg-2 pl-4 mt-2">
						<button :class="{'btn-yellow' : curShape == 'Penyok' , 'btn-outline-secondary' : curShape != 'Penyok'}" class="btn w-100" @click="curShape = 'Penyok'"><i class="fa fa-circle fa-lg mr-2 color-yellow"></i> Penyok</button>
					</div>
					<div class="col-sm-3 col-lg-2 pl-4 mt-2">
						<button :class="{'btn-red' : curShape == 'Pecah' , 'btn-outline-secondary' : curShape != 'Pecah'}" class="btn w-100" @click="curShape = 'Pecah'"><i class="fa fa-circle fa-lg mr-2 color-red"></i> Pecah</button>
					</div>
					<div class="col-sm-4 col-12 offset-lg-2 col-lg-2 pl-4 text-right mt-2">
						<button class="btn btn-danger w-100" @click="reset">Reset</button>
					</div>
						
				</div>
				<div class="col-12">
					<h4 class="text-center">Kondisi {{carTypes.charAt(0).toUpperCase() + carTypes.slice(1)}}</h4>
					<hr>
					<div class="row">
						<div class="col-4" v-for="checklistCar in Object.keys(data.condition.figure[carType].left)" :key="checklistCar">
							<div class="row mt-2">
								<div class="col-6">
									<p>{{translatePart(checklistCar).split(/(?=[A-Z])/).join(" ")}}</p>
									
								</div>
								<div class="col-6 text-center">
									<input type="checkbox" disabled  v-model="data.condition.figure[carType].left[checklistCar].desc" >
								</div>
							</div>
							<p v-if="exit && data.condition.figure[carTypes].left[checklistCar].desc != ''" style="font-weight:bold">Deskripsi Rusak : <br>{{data.condition.figure[carTypes].left[checklistCar].desc}}</p>
							<template v-else-if="exit">
								<div class="mt-5"></div>
							</template>
							<hr style="margin-top:5px;margin-bottom:5px;">
						</div>
					</div>
				</div>
			</div>
			<!-- <div class="mt-3 row">
				<template v-for="checklist in checklistSettings" >
					<div class="col-6 col-md-2 mt-2 p-3 text-center " :key="checklist.name" v-if="checklist.name.includes('LEFT_')" >
						<div 
							class="border border-secondary rounded checklist" 
							:class="{'Selected' : checkSettings[checklist.name]}" 
							
							@click="checked(checklist.name)"
						>
							<h5>{{data.condition.checklist[checklist.name] ? 'Terpilih' : 'Tidak Dipilih'}}</h5>
							<img :src="checklist.img ? checklist.img : '/img/WorkOrder/Logo/' + checklist.name.split('LEFT_')[1] + '.png'" class="img-fluid" style="width:100%;height:auto"  alt="Tidak ada Gambar"/>
							<h5>{{checklist.name.split('LEFT_')[1]}}</h5>
						</div>
					</div>
				</template>
			</div> -->
		</panel>

		<div class="row">
			<div class="col-md-6 col-0">
			</div>
			<div class="col-md-3 col-6">
				<button type="button" class="btn btn-danger w-100 rounded" @click="$emit('backPage');">Sebelumnya</button>
			</div>
			<div class="col-md-3 col-6">
				<button type="button" class="btn btn-primary w-100 rounded" @click="nextPage" :disabled="apiLoading">Berikutnya</button>
			</div>
		</div>

		<modalUploadImage :varHeader="partHeader" :var="part" :part="translatePart(part)" @showModalFalse="showModal = false" v-if="showModal" @uploadImage="uploadImage"/>

	</div>
</template>

<script>
	import Multiselect from 'vue-multiselect'
	import modalUploadImage from './modalUploadImage'
	import env from '@/env'

	export default {
		components: {
			Multiselect,
			modalUploadImage
		},
		data () {
			return {
				env,
				showModal: false,
				part: '',
				partHeader : '',
				showleftModal: false,
				carTypes : this.carType,
				checkSettings : this.data.condition.checklist,
				curShape : 'Boncel',
				listOfPoints : [],
				gridMap : null,
				gridMapMinibus : null,
				imageSrc : null
			}
		},
		props: ['page', 'data', 'checklistSettings' , 'carType', 'title' , 'exit', 'previousCheckingCondition', 'apiLoading'],
		mounted () {

			// this.mapGridCanvas()
			this.loadGridCanvas()

			if(this.exit)
				this.imageSrc = this.previousCheckingCondition.condition.figureOverall.left.image.length > 0 
				&& this.previousCheckingCondition.condition.figureOverall.left.image[0] != 'test image'? 
					this.previousCheckingCondition.condition.figureOverall.left.image[0]
					: null


			if(this.exit) {
				let keys = Object.keys(this.data.condition.figure[this.carType].left)
				console.log(this.previousCheckingCondition.condition.figure.left);

				for(var i = 0 ; i < keys.length ; i++) {
					let nowCondition = this.data.condition.figure[this.carType].left[keys[i]]
					let prevCondition = this.previousCheckingCondition.condition.figure.left[keys[i]]
					if(prevCondition.desc != '') {
						nowCondition.desc = prevCondition.desc
						console.log(nowCondition)
					}
				}
			}

			
		},
		methods: {
			async loadGridCanvas() {
				let col = [81, 8, 94, 9, 5, 7, 156, 6, 10, 97, 9, 35, 9, 22, 28, 5, 4];
				let row = [7, 12, 15, 32, 9, 6, 19, 13, 2, 7, 53, 11, 30];

				let  obj = [{
					name : 'left.rodaDepanKiri',
					startCol : 3,
					endCol  : 4,
					startRow : 11 , 
					endRow : 14
				}, {
					name : 'left.fenderDepanKiri',
					startCol : 2,
					endCol  : 5,
					startRow : 9 , 
					endRow : 13
				},{
					name : 'left.fenderBelakangKiri',
					startCol : 11,
					endCol  : 18,
					startRow : 9 , 
					endRow : 13
				}, {
					name : 'left.kacaDepanKiri',
					startCol : 7,
					endCol  : 9,
					startRow : 3 , 
					endRow : 7
				}, {
					name : 'left.kacaBelakangKiri',
					startCol : 10,
					endCol  : 11,
					startRow : 3 , 
					endRow : 6
					
				}, {
					name : 'left.kacaMiniBelakangKiri',
					startCol : 11,
					endCol  : 13,
					startRow : 4 , 
					endRow : 5
				}, {
					name : 'left.pintuDepanKiri',
					startCol : 6,
					endCol  : 10,
					startRow : 3 , 
					endRow : 12
				}, {
					name : 'left.tankiMobil',
					startCol : 15,
					endCol  : 17,
					startRow : 6 , 
					endRow : 8
				}, {
					name : 'left.pintuBelakangKiri',
					sstartCol : 9,
					endCol  : 14,
					startRow : 3 , 
					endRow : 12
				}, {
					name : 'left.sideSkirtKiri',
					startCol : 3,
					endCol  : 11,
					startRow : 12 , 
					endRow : 13
				}, {
					name : 'left.sideRoofKiri',
					startCol : 5,
					endCol  : 18,
					startRow : 2 , 
					endRow : 6
				}, {
					name : 'left.rodaBelakangKiri', 
					startCol : 12,
					endCol  : 16,
					startRow : 11 , 
					endRow : 14
				}]

				let colMinibus = [25, 19, 7,  60, 28, 9, 2, 2, 3, 15, 112, 8, 12, 9, 129, 10, 4, 18, 5, 73, 17, 7, 57]
				let rowMinibus = [3, 10, 13, 2, 8, 36.5, 3, 13, 10, 5, 50, 15, 52, 11, 2, 33]

				let objMinibus = [{
					name : 'left.rodaDepanKiri',
					startCol : 3,
					endCol  : 6,
					startRow : 13 , 
					endRow : 17
				},{
					name : 'left.rodaBelakangKiri',
					startCol : 18,
					endCol  : 21,
					startRow : 13 , 
					endRow : 17
				},{
					name : 'left.fenderDepanKiri',
					
					startCol : 2,
					endCol  : 10,
					startRow : 12 , 
					endRow : 16
				},{
					name : 'left.fenderBelakangKiri',
					startCol : 16,
					endCol  : 22,
					startRow : 12 , 
					endRow : 16
				},{
					name : 'left.kacaDepanKiri',
					startCol : 11,
					endCol  : 12,
					startRow : 6 , 
					endRow : 10
				},{
					name : 'left.kacaBelakangKiri',
					startCol : 15,
					endCol  : 17,
					startRow : 4 , 
					endRow : 9
				},{
					name : 'left.kacaPalingBelakangKiri',
					startCol : 19,
					endCol  : 23,
					startRow : 5 , 
					endRow : 8
				},{
					name : 'left.kacaMiniDepanKiri',
					startCol : 5,
					endCol  : 10,
					startRow : 7 , 
					endRow : 11
				},{
					name : 'left.pintuDepanKiri',
					startCol : 8,
					endCol  : 14,
					startRow : 4 , 
					endRow : 14
				},{
					name : 'left.pintuBelakangKiri',
					startCol : 13,
					endCol  : 20,
					startRow : 3 , 
					endRow : 14
				},{
					name : 'left.sideSkirtKiri',
					startCol : 7,
					endCol  : 16,
					startRow : 14 , 
					endRow : 16
				},{
					name : 'left.sideRoofKiri',
					startCol : 4,
					endCol  : 24,
					startRow : 2 , 
					endRow : 11
				}]

				this.gridMap = await this.mapGridCanvas(col , row , obj)
				this.gripMapMinibus = await this.mapGridCanvas(colMinibus , rowMinibus , objMinibus)
			},
			async mapGridCanvas(col , row , obj) {

				for(var i = 0 ; i < obj.length ; i++) {
					let curObj = obj[i]
					curObj.startColLength= col.slice(0 , curObj.startCol - 1).reduce((partial_sum, a) => partial_sum + a, 0)
					curObj.endColLength = col.slice(0, curObj.endCol - 1).reduce((partial_sum, a) => partial_sum + a, 0)
					curObj.startRowLength= row.slice(0 , curObj.startRow - 1).reduce((partial_sum, a) => partial_sum + a, 0)
					curObj.endRowLength = row.slice(0, curObj.endRow - 1).reduce((partial_sum, a) => partial_sum + a, 0)
					// console.log(curObj.startColLength , curObj.endColLength , curObj.startRowLength , curObj.endRowLength , curObj.name)
				}
				return obj
			},
			addShape(e = null ,click) {
				if(!e) {
					this.listOfPoints.length = 0
					// this.selected.length = 0
				}
				else {
					let x = 0
					let y = 0

					x = e.offsetX
					y = e.offsetY
					// console.log(x, y)
					

					let selectedGrid = this.carTypes == 'sedan' ? this.gridMap : this.gripMapMinibus

					let area = selectedGrid.filter(z => 
						z.startColLength <=  x &&
						z.endColLength >= x &&
						z.startRowLength <= y &&
						z.endRowLength >= y
					)

					if(area.length > 0) {
						// this.selected.push(area.name)
						
						if(area.length == 1)
							this.data.condition.figure[this.carTypes].left[area[0].name.split('.')[1]] = {
								desc : this.curShape
							}
						else {
							let res = []

							for(var i = 0 ; i < area.length ; i++) {
								let z = area[i]
								res[i] = (z.endColLength - x) + (z.endRowLength - y)
								// console.log(z.name , res[i])
							}

							var max = Math.min(...res)
							let index = res.indexOf(max)
							// console.log(area[index] , max)

							

							// this.selectPart(area[index].name , this.carTypes)
							this.data.condition.figure[this.carTypes].left[area[index].name.split('.')[1]] = {
								desc : this.curShape
							}
						}
					}
					this.listOfPoints.push({x , y , shape : this.curShape})
				}
				// console.log(click)
				let canvas = null
				let context = null

				if(this.carTypes == 'sedan') {
					canvas = document.getElementById('canvasSedan');
					context = canvas.getContext('2d');
					canvas.width = 681
					canvas.height = 489.27
				}
				else {
					canvas = document.getElementById('canvasMinibus');
					context = canvas.getContext('2d');
					canvas.width = 633.354
					canvas.height = 316.667
				}
			
				for(var i = 0 ; i < this.listOfPoints.length ; i++) {

					context.beginPath();

					let x = this.listOfPoints[i].x
					let y = this.listOfPoints[i].y

					let fillStyle = '';

					if(this.listOfPoints[i].shape == 'Boncel')
						fillStyle = '#29BC53'
					else if(this.listOfPoints[i].shape == 'Penyok')
						fillStyle = '#FFDD05'
					else if(this.listOfPoints[i].shape == 'Baret')
						fillStyle = '#007ED9'
					else if(this.listOfPoints[i].shape == 'Pecah')
						fillStyle = '#FF0000'

					// console

					context.moveTo( this.listOfPoints[i].x + 7.5, this.listOfPoints[i].y );
					context.arc(this.listOfPoints[i].x, this.listOfPoints[i].y, 7.5 ,2*Math.PI,0 *Math.PI);
					context.fillStyle = fillStyle;
					context.fill();
					context.stroke();
				}
				// var dataURL = canvas.toDataURL();
				// console.log(dataURL)
				
				
			},
			reset() {
				this.addShape(null)

				this.data.condition.figureOverall[this.carTypes].left = { image : [] }
				let keys = Object.keys(this.data.condition.figure[this.carTypes].left)
				// console.log(keys)

				for(var i = 0 ; i < keys.length ; i++) {
					this.data.condition.figure[this.carTypes].left[keys[i]] = { desc : '' }
				}
			},
			uploadImage (partHeader , part, url) {
				if(partHeader != 'figureOverall')
					this.data.condition[partHeader][this.carTypes].left[part] = url
				else 
					this.data.condition[partHeader][this.carTypes][part] = url
				// alert("Unggah Gambar Berhasil!")

				this.$store.dispatch('triggerAlert', [true, ['Unggah Gambar Berhasil']])
				this.showModal = false

				if(partHeader == 'figureOverall')
					this.$emit('nextPage')
			},
			translatePart (str) {
				let strSplit = str.split("_").reverse()

				for (var i = 0 ; i < strSplit.length ; i ++) {
					
					if(strSplit[i] == 'front')
						strSplit[i] = 'depan'
					else if (strSplit[i] == 'rear')
						strSplit[i] = 'belakang'
					else if (strSplit[i] == 'left')
						strSplit[i] = 'kiri'
					else if (strSplit[i] == 'right')
						strSplit[i] = 'kanan'
					else if (strSplit[i] == 'wheel')
						strSplit[i] = 'roda'
					else if (strSplit[i] == 'door')
						strSplit[i] = 'pintu'
					else if (strSplit[i] == 'light')
						strSplit[i] = 'lampu'
					else if (strSplit[i] == 'car')
						strSplit[i] = 'mobil'
					else if (strSplit[i] == 'window')
						strSplit[i] = 'kaca'

					strSplit[i] = strSplit[i].charAt(0).toUpperCase() + strSplit[i].slice(1)
				}

				return strSplit.join(" ")
			},
			nextPage () {
				if(this.data.condition.figureOverall[this.carTypes].left.image.length > 1) {
					this.$emit('nextPage')
				}
				if(this.exit) {
					this.showModal = true;
					this.part = 'left'
					this.partHeader = 'figureOverall'
					return
				}
				var destinationCanvas = document.createElement("CANVAS");
				var destCtx = destinationCanvas.getContext('2d');

				var background = new Image();
				let canvasId = this.carTypes == 'sedan' ? 'canvasSedan' : 'canvasMinibus'
				let param = {}

				if(this.carTypes == 'sedan') {
					destinationCanvas.width = 690
					destinationCanvas.height = 489.27
					
					background.src = "/img/WorkOrder/Sedan/CAMRY LEFT.svg";
					param.width = 680
					param.height = 250
					param.offsetX = 0
					param.offsetY = 60
					param.canvasX = 0
					param.canvasY = 68
				}
				else {
					destinationCanvas.width = 725
					destinationCanvas.height = 385
					
					background.src = "/img/WorkOrder/Minibus/ALPHARD LEFT.svg";
					param.width = 675
					param.height = 265
					param.offsetX = 23.5
					param.offsetY = 60
					param.canvasX = 55
					param.canvasY = 60
				}
				
				let vm = this
				background.onload = async function(){
					destCtx.drawImage(background, param.offsetX , param.offsetY , param.width , param.height );   
					const canvas = document.getElementById(canvasId);
					// console.log(canvas.toDataURL())
				

					destCtx.drawImage(canvas, param.canvasX ,  param.canvasY);

					let modifiedFile = vm.dataURLtoFile(destinationCanvas.toDataURL() , 'image.jpg')
					// console.log(destinationCanvas.toDataURL())
					
					let formData = new FormData()

					formData.append('work_order' , modifiedFile)
					
					
					try {
						let url = env.urlStart + "/api/v1/workorder/image"
						let response = await vm.$http.post(url , formData , {headers : {"Content-Type":'multipart/form-data'}})
						let data = response.data.data
						
						vm.data.condition.figureOverall[vm.carTypes].left = {
							image : [data.filename]
						}
						vm.$emit('nextPage')
					}   catch (err) {
						vm.$store.dispatch('triggerAlert' , [false , ['Something Went Wrong. Please Try Again Later.' , err]])
						console.log(err)
					}       
				}
			}
		}
	}
</script>

<style scoped>
	.workOrderParent {
		overflow-y:hidden;
	}

	.color-green {
		color : #29BC53;
	}
	.color-blue {
		color : #007ED9;
	}
	.color-yellow {
		color : #FFDD05;
	}
	.color-red {
		color : #FF0000;
	}

	.btn {
		border-radius: 30px;
		border : 0.5px solid;
	}

	.btn-green {
		background-color: #29BC5326;
		color : black;
	}

	.btn-blue {
		background-color: #007ED926;
		color : black;
	}
	.btn-yellow {
		background-color: #FFDD0526;
		color : black;
	}
	.btn-red {
		background-color: #FF000026;
		color : black;
	}

	.label-car-type {
		display: flex;
		align-items: center;
		letter-spacing: 0.015em;
		font-size: 14px;
	}
</style>